import { Injectable } from '@angular/core';
import { ExternalDocSearchInfo, ExternalDocument } from 'estensa-module';
import { WadoService } from '../services/wado.service';
import { EstensaExternalDocsService } from '../services/angularjs/estensa-external-docs.service';


@Injectable({
    providedIn: 'root',
})
export class ExternalDocsService {

    constructor(private estensaExternalDocsService: EstensaExternalDocsService,
        private wadoService: WadoService) {
    }


    loadAllExternalDocs(info: ExternalDocSearchInfo) {
        return this.estensaExternalDocsService.loadAllExternalDocs(info);
    }


    getExternalDoc(externalDocument: ExternalDocument) { // Vedi vna-pdf-modal per capire come fare il pipe
        let contentType: string;

        switch (externalDocument.fileType) {
            case 1: // PDF
                contentType = "application/pdf";
                break;
            case 2: // JPEG
                contentType = "image/jpeg";
                break;
            case 3: // PNG
                contentType = "image/png";
                break;
        }

        return this.wadoService.get(externalDocument.sopInstanceUID, contentType);
    }

    deleteDocument(externalDocument: ExternalDocument, isDocForPatient: boolean, displayMessage: boolean = true) {
        if (isDocForPatient)
            return this.estensaExternalDocsService.removePatientExternalDoc(externalDocument);

        return this.estensaExternalDocsService.removeExamExternalDoc(externalDocument, displayMessage);
    }

    updateDocument(externalDocument: ExternalDocument, isDocForPatient: boolean, displayMessage: boolean = true) {
        if (isDocForPatient)
            return this.estensaExternalDocsService.updatePatientExternalDoc(externalDocument);

        return this.estensaExternalDocsService.updateExamExternalDoc(externalDocument, displayMessage);
    }

    addExternaDoc(externalDocument: ExternalDocument, displayMessage: boolean = true) {
        return this.estensaExternalDocsService.uploadExternalDoc(externalDocument, displayMessage);
    }

    uploadExternalDocList(externalDocumentList: ExternalDocument[]) {
        return this.estensaExternalDocsService.uploadExternalDocList(externalDocumentList);
    }
}
